import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/landing';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-cream" aria-labelledby="faq-titulo" data-id="element-42" data-mp="1lc231ky1rhuv">
      <div className="mx-auto grid max-w-content grid-cols-1 gap-10 px-6 py-16 md:py-24 lg:grid-cols-12" data-id="element-43" data-mp="1ge0ggq1ex0en">
        <h2 id="faq-titulo" className="font-display text-3xl font-semibold leading-tight text-plum sm:text-4xl lg:col-span-4" data-id="element-44" data-mp="2dzxti7x0wdj7">
          Preguntas frecuentes
        </h2>

        <div className="border-t border-plum/15 lg:col-span-8" data-id="element-45" data-mp="240p29mtjld0j">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={faq.question} className="border-b border-plum/15" data-id="element-46" data-mp="snd49skgroma" data-mpi={index}>
                <h3 data-id="element-47" data-mp="no9yu70kngds">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-6 py-5 text-left font-sans text-lg font-semibold text-plum transition-colors duration-150 ease-soft hover:text-clay focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-clay" data-id="element-48" data-mp="nnqr1j4my8dh">
                    {faq.question}
                    <PlusIcon aria-hidden="true" className={`h-5 w-5 shrink-0 text-clay transition-transform duration-200 ease-soft ${isOpen ? 'rotate-45' : ''}`} data-id="element-49" data-mp="biongqzxvjt3" />
                  </button>
                </h3>

                <AnimatePresence initial={false} data-id="element-50" data-mp="3jz1cxx1y09c1">
                  {isOpen ? <motion.div id={`faq-panel-${index}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-51" data-mp="3nztj2hfipy43">
                      <p className="max-w-2xl pb-6 font-sans text-base leading-relaxed text-ink/75" data-id="element-52" data-mp="2dfgpbfnmcawl">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>
    </section>;
}